import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ClientApi } from "../../../apis";

function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchClients = async () => {
    try {
      const res = await ClientApi.getAllClients();
      const payload = res?.data?.data;
      const clientList = Array.isArray(payload?.clients)
        ? payload.clients
        : Array.isArray(payload)
        ? payload
        : [];
      setClients(clientList);
    } catch (error) {
      console.error("Error fetching clients:", error);
      setClients([]); // Set clients to an empty array on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <Box>
      <Grid container spacing={2} mt={2} mb={4}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Typography variant="h4" fontWeight={600}>
            Clients
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/admin/clients/add")}
          >
            Add Client
          </Button>
        </Grid>
      </Grid>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Client Nickname</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Project Count</TableCell>
                <TableCell align="right">Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No clients found.
                  </TableCell>
                </TableRow>
              ) : (
                clients.map((client) => (
                  <TableRow key={client.id}>
                    <TableCell>{client.clientNickname || "-"}</TableCell>
                    <TableCell>{client.contactNumber || client.contactName || "-"}</TableCell>
                    <TableCell>{client.company || "-"}</TableCell>
                    <TableCell>{client.phone || "-"}</TableCell>
                    <TableCell>
                      {client.projects ? client.projects.length : client.projectCount || 0}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => navigate(`/admin/clients/${client.id}`)}
                      >
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default Clients;

